<template>
  <div>
    <transition mode="out-in" name="pages">
      <router-view></router-view>
    </transition>
    <Loading v-if="loading"/>
    <cookie-policy/>
    <dialog-component/>
  </div>
</template>

<script>
import '@/assets/css/main.css';
import '@/assets/css/demonstrative-pdf.css';

import { mapState, mapActions } from 'vuex';
import api from '@/services/api';
import Loading from '@/components/Loading.vue';
import CookiePolicy from '@/components/CookiesPolicy.vue';

export default {
  components: {
    CookiePolicy,
    Loading,
  },
  methods: {
    ...mapActions('auth', ['updateUser']),
    ...mapActions('process', ['connectWs']),
  },
  computed: {
    ...mapState(['loading']),
  },
  async created() {
    if (localStorage.getItem('@GSCMX:access_token')) {
      const userResponse = await api.get('/credential');
      await this.updateUser(userResponse.data.data);
    }
  },
  async mounted() {
    await this.connectWs();
  },
};
</script>

<style>
</style>
